<template>
  <div>
      <el-button @click="getModels" type="warning" class="inline" v-if="saisit_en_ligne">
        {{ $t('posts.list.createAdFromModel') }}
      </el-button>
      <router-link :to="{ name: 'post-new' }" class="inline" v-if="saisit_en_ligne">
        <el-button type="primary">
          <span @click="$parent.eventAnalytics('creation_annonce')">
              {{ $t('posts.list.createAd') }}
          </span>
        </el-button>
      </router-link>
  </div>
</template>

<script>
export default {
  props: ['saisit_en_ligne'],
  methods: {
    getModels () {
      this.$store.dispatch('postsVo/loadModels')
    }
  }
}
</script>
